import React, { createContext, useContext, useMemo, type ReactNode } from 'react';

type FeaturesContext = {
	featureView: 'calendar' | 'calendar-embed';
	hasFilterCustomFields: boolean;
	hasInlineCreate: boolean;
	hasInviteButton: boolean;
	hasOnboarding: boolean;
	hasPresence: boolean;
	hasScheduleIssues: boolean;
	hasShareButton: boolean;
	hasSoftwareReleases: boolean;
	hasUnscheduledButton: boolean;
	inviteButtonInteraction: 'default' | 'openNewTab';
	issueViewInteraction: 'default' | 'openNewTab';
};

const defaultFeaturesContext: FeaturesContext = {
	featureView: 'calendar',
	hasFilterCustomFields: true,
	hasInlineCreate: true,
	hasInviteButton: true,
	hasOnboarding: true,
	hasPresence: true,
	hasScheduleIssues: true,
	hasShareButton: true,
	hasSoftwareReleases: true,
	hasUnscheduledButton: true,
	inviteButtonInteraction: 'default',
	issueViewInteraction: 'default',
};

const CalendarFeaturesContext = createContext<FeaturesContext>(defaultFeaturesContext);

const useCalendarFeatures = () => useContext(CalendarFeaturesContext);

type Props = Partial<FeaturesContext> & {
	children: ReactNode;
};

const CalendarFeaturesProvider = ({ children, ...props }: Props) => {
	const value = useMemo(() => ({ ...defaultFeaturesContext, ...props }), [props]);

	return (
		<CalendarFeaturesContext.Provider value={value}>{children}</CalendarFeaturesContext.Provider>
	);
};

export default CalendarFeaturesProvider;
export { useCalendarFeatures };
